export default function PesquisarOleoAplicacao(){
    return(
        "Pesquisar Oleo Aplicacao"
    )
}